<template>
  <div class="customer-form-section">
    <Load v-if="isDecryptedLoading || isMemberLoading" />

    <section
      :class="[
        'content-section seven-club-plus-section',
        { 'is-show-form': isShowForm },
      ]"
    >
      <v-container>
        <div class="text-center mb-8">
          <img
            src="@/assets/seven-club-member/logo.svg"
            height="48"
            alt="7Club+"
            class="mb-6"
          />

          <div class="headline-l mb-4">
            ลงทะเบียนรับสิทธิการจองก่อนใคร
          </div>
          <div>
            เพื่อความรวดเร็วในการสั่งจอง
            <br />
            สมาชิก
            <strong>7Club+</strong>
            สามารถกรอกข้อมูลที่อยู่จัดส่ง
            และออกใบกำกับภาษีได้ล่วงหน้า!
          </div>
        </div>

        <div class="seven-club-member-container">
          <SevenClubMember
            ref="sevenClubMember"
            :isCheckout="true"
            :isPreRegister="true"
            @verified="handleVerifySevenClubMember"
            @error="handleErrorSevenClubMember"
            @reset="reset"
          />
        </div>
        <div v-if="isMember" class="status-scm-success mt-6">
          คุณเป็นสมาชิก 7Club+ อยู่แล้ว กรุณาตรวจสอบ
          และกดยืนยันข้อมูลส่วนตัวของคุณ เพื่อความรวดเร็วในการจอง
        </div>
      </v-container>
    </section>

    <section
      v-if="!isShowForm"
      class="seven-club-plus-register-section"
    >
      <v-container>
        <div class="seven-club-plus-register">
          <div>
            หากคุณยังไม่ได้เป็นสมาชิก
            <strong>7Club+</strong>
            กับเรา
            <br />
            กดปุ่มด้านล่างสมัครสมาชิกได้เลย!
          </div>
          <BaseSevenClubPlusButton />
        </div>
      </v-container>
    </section>

    <section class="content-section form">
      <v-container v-if="isShowForm">
        <div class="customer-container">
          <div class="headline-m">
            ข้อมูลส่วนตัว
          </div>
          <div class="customer-form-container">
            <div>
              <v-text-field
                v-model="form.email"
                background-color="white"
                data-pptr="email"
                class="input-customer text-sm mt-2"
                type="email"
                ref="email"
                placeholder="อีเมล"
                outlined
                hide-details
                label="อีเมล"
                :error="$v.form.email.$error"
                color="primary"
              />
            </div>
            <div>
              <v-text-field
                v-model="form.phone"
                outlined
                background-color="white"
                data-pptr="phone"
                class="input-customer text-sm mt-2"
                maxlength="10"
                type="tel"
                ref="phone"
                hide-details
                label="เบอร์โทรศัพท์"
                :error="$v.form.phone.$error"
                color="primary"
                @keypress="isNumber($event)"
              />
            </div>
            <div>
              <v-text-field
                v-model="form.first_name"
                background-color="white"
                data-pptr="first_name"
                class="input-customer text-sm mt-2"
                type="text"
                ref="first_name"
                label="ชื่อ"
                placeholder="ชื่อ"
                outlined
                hide-details
                color="primary"
                :error="$v.form.first_name.$error"
              />
            </div>
            <div>
              <v-text-field
                v-model="form.last_name"
                background-color="white"
                data-pptr="last_name"
                class="input-customer text-sm mt-2"
                type="text"
                ref="last_name"
                placeholder="นามสกุล"
                outlined
                hide-details
                label="นามสกุล"
                :error="$v.form.last_name.$error"
                color="primary"
              />
            </div>
            <div class="span-2">
              <v-row
                v-bind="{
                  'no-gutters': true,
                }"
              >
                <v-col
                  cols="6"
                  sm="5"
                  class="input-compact-container"
                >
                  <v-select
                    v-model="form.customerIdentityType"
                    :items="[
                      {
                        text: 'เลขบัตรประชาชน',
                        value: 'id_card',
                      },
                      { text: 'Passport', value: 'passport' },
                    ]"
                    color="primary"
                    :width="150"
                    :max-width="150"
                    class="input-compact"
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col
                  cols="6"
                  sm="7"
                  class="input-compact-container"
                >
                  <v-text-field
                    v-if="form.customerIdentityType === 'id_card'"
                    outlined
                    color="primary"
                    v-model="form.customer_identity"
                    background-color="white"
                    data-pptr="customer_identity"
                    class="input-customer text-sm input-compact"
                    :error="$v.form.customer_identity.$error"
                    :error-messages="
                      handleErrorCustomerIdentity('customer_identity')
                    "
                    :hide-details="!$v.form.customer_identity.$error"
                    ref="customer_identity"
                    maxlength="17"
                    @input="
                      autoFormatIdCard($event, 'customer_identity'),
                        $v.form.customer_identity.$reset()
                    "
                    inputmode="numeric"
                    oninput="this.value=this.value.slice(0,17).replace(/[^\d]+/g, '').replace(/(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/, '$1-$2-$3-$4-$5')"
                    placeholder="เลขบัตรประชาชน"
                  />

                  <v-text-field
                    v-else
                    outlined
                    color="primary"
                    v-model="form.customer_identity"
                    background-color="white"
                    data-pptr="customer_identity"
                    class="input-customer text-sm input-compact"
                    :error="$v.form.customer_identity.$error"
                    :error-messages="
                      handleErrorCustomerIdentity('customer_identity')
                    "
                    :hide-details="!$v.form.customer_identity.$error"
                    ref="customer_identity"
                    maxlength="12"
                    oninput="this.value=this.value.slice(0,12).replace(/[^\w]+/g, '')"
                    placeholder="Passport"
                  />
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="headline-m">
            ที่อยู่ในการจัดส่ง/ออกใบเสร็จ
          </div>

          <div class="customer-form-container">
            <div class="span-2">
              <v-text-field
                v-model="form.address"
                outlined
                background-color="white"
                data-pptr="address"
                class="input-customer text-sm"
                type="text"
                ref="address"
                hide-details
                label="บ้านเลขที่,ห้อง,หมู่บ้าน,ชื่ออาคาร,ตึก,คอนโด"
                :error="$v.form.address.$error"
                color="primary"
              />
            </div>

            <div class="span-2">
              <BaseAddress
                :postcode="form.postcode"
                :errorPostcode="$v.form.postcode.$error"
                :province="form.province"
                :errorProvince="$v.form.province.$error"
                :district="form.district"
                :errorDistrict="$v.form.district.$error"
                :subDistrict="form.sub_district"
                :errorSubDistrict="$v.form.sub_district.$error"
                @update:postcode="form.postcode = $event"
                @update:province="form.province = $event"
                @update:district="form.district = $event"
                @update:subDistrict="form.sub_district = $event"
              />
            </div>

            <template v-if="samsungHandraiser">
              <div class="span-2">
                <v-row>
                  <v-col cols="12" md="12" class="py-0">
                    <v-autocomplete
                      v-model="form.additional_description.brand"
                      ref="taxSubDistrict"
                      clearable
                      background-color="white"
                      class="text-sm"
                      data-pptr="brand"
                      item-text="brand"
                      item-value="brand"
                      placeholder="ยี่ห้อมือถือที่ใช้งานอยู่"
                      color="primary"
                      :items="additionalDescriptionBrand"
                      @click:clear="
                        form.additional_description.model = ''
                      "
                      outlined
                      label="ยี่ห้อมือถือที่ใช้งานอยู่"
                      hide-details
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="12" class="py-0">
                    <v-autocomplete
                      outlined
                      v-model="form.additional_description.model"
                      color="primary"
                      :items="additionalDescriptionModel"
                      :error="
                        $v.form.additional_description.model.$error
                      "
                      :error-messages="
                        $v.form.additional_description.model.$error
                          ? 'กรุณาเลือกรุ่นมือถือที่ใช้งานอยู่'
                          : ''
                      "
                      :class="{
                        'has-error':
                          $v.form.additional_description.model.$error,
                      }"
                      clearable
                      background-color="white"
                      class="text-sm"
                      data-pptr="model"
                      item-text="model"
                      item-value="model"
                      hide-details
                      label="รุ่นมือถือที่ใช้งานอยู่"
                      ref="taxSubDistrict"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </div>

              <div class="span-2">
                <v-autocomplete
                  outlined
                  v-model="form.additional_description.interest_item"
                  color="primary"
                  :items="additionalDescriptionInterest"
                  clearable
                  background-color="white"
                  class="text-sm"
                  data-pptr="interest_item"
                  item-text="interest_item"
                  item-value="interest_item"
                  hide-details
                  label="ลูกค้าสนใจ promotion แลกซื้อหรือไม่ / หากสนใจเป็นสินค้าใด?"
                  ref="interest_item"
                ></v-autocomplete>
              </div>
            </template>
          </div>

          <div class="headline-m">
            ที่อยู่ใบกำกับภาษี
          </div>

          <div class="customer-form-container">
            <div class="span-2" v-if="customFieldOnCart">
              <h3 class="text-xl font-semibold">
                <v-checkbox
                  :input-value="form.need_true_phone"
                  :true-value="true"
                  color="primary"
                  hide-details
                  label="ต้องการเปิดเบอร์ True รับส่วนลดสูงสุด 8,800 บาท"
                  background-color="#f5f5f7"
                  @click="checkNeedTruePhone"
                ></v-checkbox>
              </h3>
            </div>
            <div class="span-2">
              <h3 class="text-xl font-semibold">
                <v-checkbox
                  v-model="form.checkReceipt"
                  :true-value="true"
                  color="primary"
                  hide-details
                  label="ต้องการรับใบกำกับภาษี / แก้ไขใบเสร็จ"
                  background-color="#f5f5f7"
                ></v-checkbox>
              </h3>
              <div class="warning-tax-invoice studio-7">
                <div class="warning-tax-invoice-title">
                  <span class="text-alert">สำคัญ!</span>
                  ใบกำกับภาษีของคุณจะถูกจัดส่งทางอีเมล
                </div>
                <div>
                  กรุณาตรวจสอบชื่อและที่อยู่ในการออกใบกำกับภาษีให้ถูกต้องทุกครั้ง
                  ทางบริษัทฯขอสงวนสิทธิ์ในการแก้ไขใบกำกับภาษี
                </div>
              </div>
            </div>

            <template v-if="form.checkReceipt">
              <div>
                <v-radio-group
                  v-model="form.taxInvoiceType"
                  inline
                  :error="$v.form.taxInvoiceType.$error"
                  ref="taxInvoiceType"
                  data-pptr="taxInvoiceType"
                >
                  <v-radio
                    :label="`ใบกำกับภาษีส่วนบุคคล`"
                    hide-details
                    value="PERSONAL"
                    color="primary"
                  ></v-radio>
                </v-radio-group>
              </div>

              <div>
                <v-radio-group
                  v-model="form.taxInvoiceType"
                  inline
                  :error="$v.form.taxInvoiceType.$error"
                  ref="taxInvoiceType"
                  data-pptr="taxInvoiceType"
                >
                  <v-radio
                    hide-details
                    value="CORPORATION"
                    :label="`ใบกำกับภาษีนิติบุคคล`"
                    color="primary"
                  ></v-radio>
                </v-radio-group>
              </div>

              <!-- Personal -->
              <template v-if="checkTaxPersonal">
                <div class="span-2">
                  <v-row
                    v-bind="{
                      'no-gutters': true,
                    }"
                  >
                    <v-col
                      cols="6"
                      sm="5"
                      class="input-compact-container"
                    >
                      <v-select
                        v-model="form.checkTaxPersonalType"
                        :items="[
                          {
                            text: 'เลขประจำตัวผู้เสียภาษี',
                            value: 'id_card',
                          },
                          { text: 'Passport', value: 'passport' },
                        ]"
                        color="primary"
                        :width="150"
                        :max-width="150"
                        class="input-compact"
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="7"
                      class="input-compact-container"
                    >
                      <v-text-field
                        v-if="form.checkTaxPersonalType === 'id_card'"
                        outlined
                        color="primary"
                        v-model="form.tax_id"
                        background-color="white"
                        data-pptr="tax_id"
                        class="input-customer text-sm input-compact"
                        :error="$v.form.tax_id.$error"
                        :error-messages="
                          handleErrorCustomerIdentity('tax_id')
                        "
                        :hide-details="!$v.form.tax_id.$error"
                        ref="tax_id"
                        maxlength="17"
                        @input="
                          autoFormatIdCard($event, 'tax_id'),
                            $v.form.tax_id.$reset()
                        "
                        inputmode="numeric"
                        oninput="this.value=this.value.slice(0,17).replace(/[^\d]+/g, '').replace(/(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/, '$1-$2-$3-$4-$5')"
                        placeholder="เลขประจำตัวผู้เสียภาษี"
                      />

                      <v-text-field
                        v-if="
                          form.checkTaxPersonalType === 'passport'
                        "
                        outlined
                        color="primary"
                        v-model="form.tax_id"
                        background-color="white"
                        data-pptr="tax_id"
                        class="input-customer text-sm input-compact"
                        :error="$v.form.tax_id.$error"
                        :error-messages="
                          handleErrorCustomerIdentity('tax_id')
                        "
                        :hide-details="!$v.form.tax_id.$error"
                        ref="tax_id"
                        maxlength="12"
                        oninput="this.value=this.value.slice(0,12).replace(/[^\w]+/g, '')"
                        placeholder="Passport"
                      />
                    </v-col>
                  </v-row>
                </div>

                <div>
                  <v-text-field
                    v-model="form.taxFirstName"
                    background-color="white"
                    data-pptr="taxFirstName"
                    class="input-customer text-sm"
                    ref="taxFirstName"
                    maxlength="100"
                    type="text"
                    color="primary"
                    :error="$v.form.taxFirstName.$error"
                    outlined
                    hide-details
                    label="ชื่อ"
                  />
                </div>
                <div>
                  <v-text-field
                    outlined
                    hide-details
                    label="นามสกุล"
                    v-model="form.taxLastName"
                    background-color="white"
                    data-pptr="taxLastName"
                    class="input-customer text-sm"
                    maxlength="100"
                    ref="taxLastName"
                    type="text"
                    color="primary"
                    :error="$v.form.taxLastName.$error"
                  />
                </div>
              </template>
              <!-- Company -->
              <template v-if="checkTaxJuristic">
                <div>
                  <v-text-field
                    v-model="form.tax_id"
                    outlined
                    color="primary"
                    background-color="white"
                    data-pptr="tax_id"
                    class="input-customer text-sm input-compact"
                    :error="$v.form.tax_id.$error"
                    :error-messages="
                      handleErrorCustomerIdentity('tax_id')
                    "
                    :hide-details="!$v.form.tax_id.$error"
                    ref="tax_id"
                    maxlength="17"
                    @input="
                      autoFormatIdCard($event, 'tax_id'),
                        $v.form.tax_id.$reset()
                    "
                    oninput="this.value=this.value.slice(0,17).replace(/[^\d]+/g, '').replace(/(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/, '$1-$2-$3-$4-$5')"
                    inputmode="numeric"
                    placeholder="เลขประจำตัวผู้เสียภาษี"
                    label="เลขประจำตัวผู้เสียภาษี"
                  />
                </div>

                <div></div>
                <div>
                  <v-text-field
                    outlined
                    hide-details
                    label="ชื่อบริษัท"
                    v-model="form.taxCompanyName"
                    background-color="white"
                    data-pptr="taxCompanyName"
                    class="input-customer text-sm"
                    maxlength="100"
                    type="text"
                    ref="taxCompanyName"
                    placeholder="ชื่อบริษัท"
                    color="primary"
                    :error="$v.form.taxCompanyName.$error"
                  />
                </div>
                <div>
                  <v-text-field
                    outlined
                    hide-details
                    label="รหัสสาขา"
                    v-model="form.taxCompanyCode"
                    background-color="white"
                    data-pptr="taxCompanyCode"
                    class="input-customer text-sm"
                    maxlength="100"
                    type="text"
                    ref="taxCompanyCode"
                    placeholder="รหัสสาขา"
                    color="primary"
                    :error="$v.form.taxCompanyCode.$error"
                  />
                </div>
              </template>

              <div class="span-2">
                <h3 class="text-xl">
                  <v-checkbox
                    class="mt-0"
                    v-model="form.sameAsDeliveryAddress"
                    hide-details
                    :label="`ที่อยู่เดียวกับที่อยู่จัดส่ง`"
                    :true-value="true"
                    color="primary"
                    background-color="#f5f5f7"
                  ></v-checkbox>
                </h3>
              </div>

              <template v-if="!form.sameAsDeliveryAddress">
                <div>
                  <v-text-field
                    outlined
                    hide-details
                    label="บ้าน/อาคาร/เลขที่"
                    v-model="form.taxAddress1"
                    background-color="white"
                    data-pptr="taxAddress1"
                    class="input-customer text-sm"
                    maxlength="100"
                    type="text"
                    ref="taxAddress1"
                    color="primary"
                    :error="$v.form.taxAddress1.$error"
                  />
                </div>
                <div>
                  <v-text-field
                    outlined
                    hide-details
                    label="หมู่บ้าน/อาคาร/สถานที่"
                    v-model="form.taxAddress2"
                    background-color="white"
                    data-pptr="taxAddress2"
                    class="input-customer text-sm"
                    maxlength="100"
                    type="text"
                    ref="taxAddress2"
                    color="primary"
                  />
                </div>
                <div class="span-2">
                  <v-text-field
                    outlined
                    hide-details
                    label="ที่อยู่/ถนน/ซอย"
                    v-model="form.taxAddress3"
                    background-color="white"
                    data-pptr="taxAddress3"
                    class="input-customer text-sm"
                    maxlength="100"
                    type="text"
                    ref="taxAddress3"
                    placeholder="ที่อยู่/ถนน/ซอย"
                    color="primary"
                    :error="$v.form.taxAddress3.$error"
                  />
                </div>

                <div class="span-2">
                  <BaseAddress
                    :postcode="form.taxPostcode"
                    :errorPostcode="$v.form.taxPostcode.$error"
                    :province="form.taxProvince"
                    :errorProvince="$v.form.taxProvince.$error"
                    :district="form.taxDistrict"
                    :errorDistrict="$v.form.taxDistrict.$error"
                    :subDistrict="form.taxSubDistrict"
                    :errorSubDistrict="$v.form.taxSubDistrict.$error"
                    @update:postcode="form.taxPostcode = $event"
                    @update:province="form.taxProvince = $event"
                    @update:district="form.taxDistrict = $event"
                    @update:subDistrict="form.taxSubDistrict = $event"
                  />
                </div>

                <div>
                  <v-text-field
                    outlined
                    hide-details
                    label="เบอร์โทรศัพท์"
                    v-model="form.taxPhoneNumber"
                    background-color="white"
                    data-pptr="taxPhoneNumber"
                    class="input-customer text-sm"
                    maxlength="10"
                    type="tel"
                    ref="taxPhoneNumber"
                    placeholder="เบอร์โทรศัพท์"
                    color="primary"
                    :error="$v.form.taxPhoneNumber.$error"
                    @keypress="isNumber($event)"
                  />
                </div>
              </template>
            </template>
          </div>
        </div>
      </v-container>
    </section>

    <section v-if="isShowForm" class="action-container">
      <v-container>
        <div class="action-content">
          <v-btn
            v-if="registeredOrderType === 'offline'"
            depressed
            rounded
            large
            outlined
            color="primary"
            class="btn-action"
            @click="handleScanQrCode"
          >
            <v-icon size="16" class="mr-2">
              mdi-qrcode-scan
            </v-icon>
            สแกน QR Code
          </v-btn>
          <v-btn
            depressed
            large
            class="btn-action font-bold"
            color="primary"
            @click="submitForm"
          >
            ยืนยันข้อมูลของคุณ
          </v-btn>
        </div>
      </v-container>
    </section>

    <v-dialog v-model="dialog" persistent max-width="375">
      <v-card>
        <div class="header-modal-container">
          <div class="header-modal">
            <span class="header-modal-title">
              <div class="d-flex">
                <span class="font-bold text-black">
                  ล้างข้อมูล
                </span>
              </div>
            </span>
          </div>
        </div>

        <div class="body-modal">
          <v-row v-bind="{ justify: 'end', 'no-gutters': true }">
            <v-col class="text-center">
              คุณแน่ใจหรือไม่ว่าต้องการล้างข้อมูลทั้งหมด
            </v-col>

            <v-col cols="12" class="mt-8">
              <v-btn
                block
                depressed
                large
                color="#FF4252"
                class="text-white font-bold"
                @click="reset"
              >
                ยืนยันล้างข้อมูล
              </v-btn>
            </v-col>

            <v-col cols="12" class="mt-4">
              <v-btn
                block
                depressed
                link
                large
                @click="closeResetModal"
              >
                ยกเลิก
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="lineRegisteredDialog"
      persistent
      max-width="375"
    >
      <v-card>
        <div class="body-modal">
          <div class="flash-message-container">
            <h2>
              ข้อมูลถูกบันทึกเรียบร้อยแล้ว 🎉
            </h2>

            <div class="text-center">
              กรุณารอดำเนินการต่อในเวลาแคมเปญ
              <div class="font-bold">
                {{ startedAt }}
              </div>
            </div>

            <v-btn
              block
              depressed
              large
              color="primary"
              class="text-white font-bold"
              @click="closeLineRegisteredDialog"
            >
              ตกลง
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="registeredOrderTypeDialog"
      persistent
      max-width="375"
    >
      <v-card>
        <div class="body-modal">
          <div class="register-delivery-method-modal">
            <div class="register-delivery-method-title text-center">
              คุณสนใจทำการลงทะเบียนสั่งจอง
              <span class="font-bold">
                {{ campaignName }}
              </span>
              ล่วงหน้าทางใด
            </div>

            <div class="register-delivery-method-list">
              <div
                :class="[
                  'item',
                  {
                    '-is-selected': registeredOrderType === 'offline',
                  },
                ]"
                @click="registeredOrderType = 'offline'"
              >
                <div class="item-icon">
                  <img
                    :src="
                      require('@/assets/icon/icon-pick-at-store-type.svg')
                    "
                  />
                </div>
                <div class="item-label">
                  สั่งซื้อหน้าร้าน
                </div>
              </div>

              <div
                :class="[
                  'item',
                  {
                    '-is-selected': registeredOrderType === 'online',
                  },
                ]"
                @click="registeredOrderType = 'online'"
              >
                <div class="item-icon">
                  <img
                    :src="
                      require('@/assets/icon/studio7/icon-cart.svg')
                    "
                  />
                </div>
                <div class="item-label">
                  สั่งซื้อออนไลน์
                </div>
              </div>
            </div>

            <v-btn
              block
              depressed
              large
              color="primary"
              class="text-white font-bold"
              :disabled="!registeredOrderType"
              @click="confirmRegisteredOrderType"
            >
              ตกลง
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="openLinkDialog" persistent max-width="375">
      <v-card>
        <div class="header-modal-container">
          <div class="header-modal">
            <span class="header-modal-title">
              <div class="d-flex">
                <span class="font-bold text-black">
                  เปิดลิงก์
                </span>
              </div>
            </span>
          </div>
        </div>

        <div class="body-modal">
          <v-row v-bind="{ justify: 'end', 'no-gutters': true }">
            <v-col class="text-center">
              อุปกรณ์ไม่อนุญาตให้เปิด Pop-up โดยอัตโนมัติ
              กรุณากดปุ่มด้านล่างเพื่อไปยังหน้าสินค้า
            </v-col>

            <v-col cols="12" class="mt-8">
              <v-btn
                block
                depressed
                large
                color="primary"
                class="text-white font-bold"
                :href="scannedLink"
                target="_blank"
                rel="noopener"
                @click="closeOpenLinkDialog"
              >
                เปิดลิงก์
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>

    <ModalSevenClubMember ref="sevenClubMemberModal" />

    <BaseBarcodeReader
      ref="barcodeReaderRef"
      :isValidResult="isSameOriginUrl"
      invalidResultMessage="QR Code นี้ไม่สามารถใช้งานได้ กรุณาตรวจสอบอีกครั้ง"
      @result="handleResultReader"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
  maxLength,
  numeric,
  requiredIf,
} from 'vuelidate/lib/validators'
import moment from 'moment'
import branchTypes from '@/config/branchTypes'
import additionalDescription from '@/config/additionalDescription'
import {
  validateIdCard,
  validateStartWithZero,
  validatePassport,
  getRegisteredStorageKey,
  getMemberVerifiedStorageKey,
  getRegisteredOrderStorageKey,
  isSameOriginUrl,
} from '@/utils/helpers'

export default {
  name: 'SevenClubPlusInformationForm',

  mixins: [validationMixin],

  components: {
    // Delivery,
    SevenClubMember: () =>
      import('@/components/bnn/SevenClubMember.vue'),
    Load: () => import('@/views/Load.vue'),
    BaseAddress: () => import('@/components/base/BaseAddress.vue'),
    BaseSevenClubPlusButton: () =>
      import('@/components/base/BaseSevenClubPlusButton.vue'),
    ModalSevenClubMember: () =>
      import('@/components/bnn/ModalSevenClubMember.vue'),
    BaseBarcodeReader: () =>
      import('@/components/base/BaseBarcodeReader.vue'),
  },

  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
      isMemberLoading: state => state.user.member.isLoading,
      isVerifySuccess: state => state.user.member.isVerifySuccess,
      member: state => state.user.member.data,
      isError: state => state.user.member.isError,
    }),
    startedAt() {
      return moment
        .unix(this.campaign.data?.started_at_timestamp)
        .format('DD MMMM YYYY, เวลา HH:mm น.')
    },
    customFieldOnCart() {
      return false
    },
    samsungHandraiser() {
      return this.campaign.data?.handraiser === 'samsung'
    },
    provinceData() {
      return this.$store.getters['thailandStore/getProvince']
    },
    districtData() {
      return this.$store.getters['thailandStore/getDistrict'](
        this.form.province,
      )
    },
    taxDistrictData() {
      return this.$store.getters['thailandStore/getDistrict'](
        this.form.taxProvince,
      )
    },
    zipcodeData() {
      return this.$store.getters['thailandStore/getZipcode'](
        this.form.district,
        this.form.sub_district,
      )
    },
    taxZipcodeData() {
      return this.$store.getters['thailandStore/getZipcode'](
        this.form.taxDistrict,
        this.form.taxSubDistrict,
      )
    },
    taxSubDistrictData() {
      return this.$store.getters['thailandStore/getSubDistrict'](
        this.form.taxProvince,
        this.form.taxDistrict,
      )
    },
    subDistrictData() {
      return this.$store.getters['thailandStore/getSubDistrict'](
        this.form.province,
        this.form.district,
      )
    },
    checkTaxPersonal() {
      return this.form.taxInvoiceType === 'PERSONAL'
    },
    checkTaxJuristic() {
      return this.form.taxInvoiceType === 'CORPORATION'
    },
    additionalDescriptionBrand() {
      let brands = additionalDescription.model.map(item => item.brand)
      return brands.filter(
        (brand, index) => brands.indexOf(brand) === index,
      )
    },
    additionalDescriptionModel() {
      return additionalDescription.model
        .filter(
          item =>
            item.brand === this.form.additional_description.brand,
        )
        .map(item => item.model)
    },
    additionalDescriptionInterest() {
      return additionalDescription.interestItem
    },
    decryptedData() {
      return this.$store.getters['user/getData']
    },
    isMember() {
      return !!this.localMember || !!this.member
    },
    isShowForm() {
      return this.isMember
    },
    isLineChannelRef() {
      return this.$route.query['channel-ref'] === 'line'
    },
    campaignName() {
      return this.campaign?.data?.name
    },
  },

  data() {
    return {
      dialog: false,
      lineRegisteredDialog: false,
      registeredOrderTypeDialog: false,
      openLinkDialog: false,
      scannedLink: null,
      registeredOrderType:
        localStorage.getItem(
          getRegisteredOrderStorageKey(this.$route.params?.slug),
        ) || null,
      localMember:
        localStorage.getItem(
          getMemberVerifiedStorageKey(this.$route.params?.slug),
        ) || '',

      branchTypes,

      initForm: {
        first_name: '',
        last_name: '',
        customer_identity: '',
        phone: '',
        email: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        postcode: '',
        need_true_phone: false,
        checkReceipt: false,
        checkTaxPersonal: false,
        checkTaxJuristic: false,
        taxInvoiceType: 'PERSONAL', //  'PERSONAL', 'CORPORATION'
        tax_id: '',
        taxFirstName: '',
        taxLastName: '',
        taxCompanyName: '',
        taxCompanyCode: '',
        taxAddress1: '',
        taxAddress2: '',
        taxAddress3: '',
        taxProvince: '',
        taxDistrict: '',
        taxSubDistrict: '',
        taxPostcode: '',
        taxPhoneNumber: '',

        // other
        for_work: false,

        // additional_description
        additional_description: {
          brand: '',
          model: '',
          interest_item: '',
        },

        // Don't send to API
        sameAsDeliveryAddress: true, // tax address same as delivery address
        customerIdentityType: 'id_card', // id_card, passport
        checkTaxPersonalType: 'id_card', // id_card, passport
      },
      form: {
        first_name: '',
        last_name: '',
        customer_identity: '',
        phone: '',
        email: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        postcode: '',
        need_true_phone: false,
        checkReceipt: false,
        checkTaxPersonal: false,
        checkTaxJuristic: false,
        taxInvoiceType: 'PERSONAL', //  'PERSONAL', 'CORPORATION'
        tax_id: '',
        taxFirstName: '',
        taxLastName: '',
        taxCompanyName: '',
        taxCompanyCode: '',
        taxAddress1: '',
        taxAddress2: '',
        taxAddress3: '',
        taxProvince: '',
        taxDistrict: '',
        taxSubDistrict: '',
        taxPostcode: '',
        taxPhoneNumber: '',

        // other
        for_work: false,

        // additional_description
        additional_description: {
          brand: '',
          model: '',
          interest_item: '',
        },

        // Don't send to API
        sameAsDeliveryAddress: false, // tax address same as delivery address
        customerIdentityType: 'id_card', // id_card, passport
        checkTaxPersonalType: 'id_card', // id_card, passport
      },

      errorIdCardFormat: false,
      errorTaxIdFormat: false,
      isDecryptedLoading: false,
    }
  },

  validations: {
    form: {
      email: { required, email, maxLength: maxLength(40) },
      phone: { required, numeric, maxLength: maxLength(20) },
      first_name: { required, maxLength: maxLength(40) },
      last_name: { required, maxLength: maxLength(40) },
      customer_identity: {
        required,
        valid: function(value) {
          if (this.form.customerIdentityType === 'id_card') {
            return validateIdCard(value)
          } else if (this.form.customerIdentityType === 'passport') {
            return validatePassport(value)
          }
          return true
        },
      },
      address: { required, maxLength: maxLength(100) },
      postcode: { required, maxLength: maxLength(5) },
      province: {
        required,
        maxLength: maxLength(100),
        valid: function(value) {
          return this.provinceData.some(
            item => item.province === value,
          )
        },
      },
      district: {
        required,
        maxLength: maxLength(100),
        valid: function(value) {
          return this.districtData.some(item => item.amphoe === value)
        },
      },
      sub_district: {
        required,
        maxLength: maxLength(100),
        valid: function(value) {
          return this.subDistrictData.some(
            item => item.district === value,
          )
        },
      },

      taxInvoiceType: {
        required: requiredIf(function() {
          return this.form.checkReceipt
        }),
      },
      tax_id: {
        required: requiredIf(function() {
          return this.form.checkReceipt
        }),
        valid: function(value) {
          if (this.form.checkReceipt) {
            if (this.checkTaxPersonal) {
              if (this.form.checkTaxPersonalType === 'passport') {
                return validatePassport(value)
              }

              return validateIdCard(value)
            } else if (this.checkTaxJuristic) {
              return validateStartWithZero(value)
            }
          }
          return true
        },
      },
      taxFirstName: {
        required: requiredIf(function() {
          return this.form.checkReceipt && this.checkTaxPersonal
        }),
      },
      taxLastName: {
        required: requiredIf(function() {
          return this.form.checkReceipt && this.checkTaxPersonal
        }),
      },
      taxCompanyName: {
        required: requiredIf(function() {
          return this.form.checkReceipt && this.checkTaxJuristic
        }),
      },
      taxCompanyCode: {
        required: requiredIf(function() {
          //   return this.form.checkReceipt && this.checkTaxJuristic
          return false
        }),
      },
      taxAddress1: {
        required: requiredIf(function() {
          return (
            this.form.checkReceipt && !this.form.sameAsDeliveryAddress
          )
        }),
      },
      taxAddress3: {
        required: requiredIf(function() {
          //   return (
          //     this.form.checkReceipt && !this.form.sameAsDeliveryAddress
          //   )
          return false
        }),
      },
      taxProvince: {
        required: requiredIf(function() {
          return (
            this.form.checkReceipt && !this.form.sameAsDeliveryAddress
          )
        }),
        valid: function(value) {
          return this.form.checkReceipt &&
            !this.form.sameAsDeliveryAddress
            ? this.provinceData.some(item => item.province === value)
            : true
        },
      },
      taxDistrict: {
        required: requiredIf(function() {
          return (
            this.form.checkReceipt && !this.form.sameAsDeliveryAddress
          )
        }),
        valid: function(value) {
          return this.form.checkReceipt &&
            !this.form.sameAsDeliveryAddress
            ? this.taxDistrictData.some(item => item.amphoe === value)
            : true
        },
      },
      taxSubDistrict: {
        required: requiredIf(function() {
          return (
            this.form.checkReceipt && !this.form.sameAsDeliveryAddress
          )
        }),
        valid: function(value) {
          return this.form.checkReceipt &&
            !this.form.sameAsDeliveryAddress
            ? this.taxSubDistrictData.some(
                item => item.district === value,
              )
            : true
        },
      },
      taxPostcode: {
        required: requiredIf(function() {
          return (
            this.form.checkReceipt && !this.form.sameAsDeliveryAddress
          )
        }),
      },
      taxPhoneNumber: {
        required: requiredIf(function() {
          return (
            this.form.checkReceipt && !this.form.sameAsDeliveryAddress
          )
        }),
      },
      additional_description: {
        model: {
          required: requiredIf(function() {
            return this.form.additional_description.brand
          }),
        },
      },
    },
  },

  watch: {
    checkTaxPersonal(val) {
      if (val) {
        if (this.decryptedData.taxInvoiceType === 'PERSONAL') {
          this.form.tax_id = this.decryptedData.checkReceipt
            ? this.decryptedData.tax_id
            : this.form.customer_identity
          this.form.taxFirstName =
            this.decryptedData.taxFirstName || this.form.first_name
          this.form.taxLastName =
            this.decryptedData.taxLastName || this.form.last_name

          if (!this.decryptedData.sameAsDeliveryAddress) {
            this.form.sameAsDeliveryAddress = this.decryptedData.sameAsDeliveryAddress
            this.form.taxAddress1 =
              this.form.taxAddress1 || this.decryptedData.taxAddress1
            this.form.taxAddress2 =
              this.form.taxAddress2 || this.decryptedData.taxAddress2
            this.form.taxAddress3 =
              this.form.taxAddress3 || this.decryptedData.taxAddress3
            this.form.taxSubDistrict =
              this.form.taxSubDistrict ||
              this.decryptedData.taxSubDistrict
            this.form.taxDistrict =
              this.form.taxDistrict || this.decryptedData.taxDistrict
            this.form.taxProvince =
              this.form.taxProvince || this.decryptedData.taxProvince
            this.form.taxPostcode =
              this.form.taxPostcode || this.decryptedData.taxPostcode
            this.form.taxPhoneNumber =
              this.form.taxPhoneNumber ||
              this.decryptedData.taxPhoneNumber
          } else {
            this.form.sameAsDeliveryAddress = true
            this.form.taxAddress1 = ''
            this.form.taxAddress2 = ''
            this.form.taxAddress3 = ''
            this.form.taxSubDistrict = ''
            this.form.taxDistrict = ''
            this.form.taxProvince = ''
            this.form.taxPostcode = ''
            this.form.taxPhoneNumber = ''
          }
        } else {
          this.form.tax_id = this.form.customer_identity
          this.form.taxFirstName =
            this.form.taxFirstName || this.form.first_name
          this.form.taxLastName =
            this.form.taxLastName || this.form.last_name
          this.form.sameAsDeliveryAddress = true
          this.form.taxAddress1 = ''
          this.form.taxAddress2 = ''
          this.form.taxAddress3 = ''
          this.form.taxSubDistrict = ''
          this.form.taxDistrict = ''
          this.form.taxProvince = ''
          this.form.taxPostcode = ''
          this.form.taxPhoneNumber = ''
        }
      }
    },
    checkTaxJuristic(val) {
      if (val) {
        this.form.sameAsDeliveryAddress = false

        if (this.decryptedData.taxInvoiceType === 'CORPORATION') {
          this.form.tax_id = this.decryptedData.tax_id || ''
          this.form.taxCompanyName =
            this.form.taxCompanyName ||
            this.decryptedData.taxCompanyName
          this.form.taxCompanyCode =
            this.form.taxCompanyCode ||
            this.decryptedData.taxCompanyCode
        } else {
          if (!this.decryptedData.taxCompanyName) {
            this.form.tax_id = ''
            this.form.taxCompanyName = ''
            this.form.taxCompanyCode = ''
          } else {
            this.form.tax_id = this.decryptedData.tax_id || ''
            this.form.taxCompanyName =
              this.decryptedData.taxCompanyName || ''
            this.form.taxCompanyCode =
              this.decryptedData.taxCompanyCode || ''
          }
        }

        this.form.taxAddress1 =
          this.form.taxAddress1 || this.decryptedData.taxAddress1
        this.form.taxAddress2 =
          this.form.taxAddress2 || this.decryptedData.taxAddress2
        this.form.taxAddress3 =
          this.form.taxAddress3 || this.decryptedData.taxAddress3
        this.form.taxProvince =
          this.form.taxProvince || this.decryptedData.taxProvince
        this.form.taxDistrict =
          this.form.taxDistrict || this.decryptedData.taxDistrict
        this.form.taxSubDistrict =
          this.form.taxSubDistrict ||
          this.decryptedData.taxSubDistrict
        this.form.taxPostcode =
          this.form.taxPostcode || this.decryptedData.taxPostcode
        this.form.taxPhoneNumber =
          this.form.taxPhoneNumber ||
          this.decryptedData.taxPhoneNumber
      }
    },
    isVerifySuccess(val) {
      if (val) {
        this.handleVerifySevenClubMember()
      }
    },
  },

  async mounted() {
    // Ensure close the scanner modal before opening the new window
    this.$nextTick(() => {
      this.$refs.barcodeReaderRef?.closeScanner()
    })

    if (this.campaign?.data?.redirect_url) {
      window.location.href = this.campaign?.data?.redirect_url
    }

    this.prepareDataForm()

    if (this.isLineChannelRef && !this.registeredOrderType) {
      this.registeredOrderTypeDialog = true
    } else {
      await this.checkMemberRequestKey()
    }
  },

  methods: {
    async prepareDataForm() {
      this.isDecryptedLoading = true

      this.$store.dispatch('user/fetchData')

      this.form = { ...this.form, ...this.decryptedData }

      this.isDecryptedLoading = false

      this.form.sameAsDeliveryAddress = this.decryptedData.sameAsDeliveryAddress
      this.form.customerIdentityType =
        this.decryptedData.customerIdentityType ?? 'id_card'
      this.form.checkTaxPersonalType =
        this.decryptedData.checkTaxPersonalType ?? 'id_card'

      // Auto replace format customer_identity
      if (this.form.customer_identity) {
        this.form.customer_identity = this.form.customer_identity.replace(
          /(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/,
          '$1-$2-$3-$4-$5',
        )
      }

      // Set default value
      if (!this.decryptedData.checkReceipt) {
        // data checkReceipt is false
        // Default value for tax personal
        this.form.tax_id = this.form.customer_identity
        this.form.taxFirstName = this.form.first_name
        this.form.taxLastName = this.form.last_name
        this.form.sameAsDeliveryAddress = true
      } else {
        this.form.tax_id =
          this.decryptedData.tax_id || this.form.customer_identity
        this.form.taxFirstName =
          this.decryptedData.taxFirstName || this.form.first_name
        this.form.taxLastName =
          this.decryptedData.taxLastName || this.form.last_name
      }

      // ------
    },

    async checkMemberRequestKey() {
      const memberRequestKey = this.$route.query.member_request_key
      if (!memberRequestKey) {
        return
      }

      try {
        // Clear the member state before fetching new data
        this.resetBeforeFetchMember()

        await this.$store.dispatch('user/getMemberByKey', {
          clubmember_key: memberRequestKey,
        })

        if (this.$store.state.user.member?.isSuccess) {
          this.handleVerifySevenClubMember()
          this.$refs.sevenClubMember?.handleUpdatePhoneNumber()
        }
      } catch {
        // If needed
      }
    },

    handleScanQrCode() {
      this.$refs.barcodeReaderRef.openScanner()
    },

    isSameOriginUrl(value) {
      return isSameOriginUrl(value)
    },

    async handleResultReader(link) {
      // Ensure close the scanner modal before opening the new window
      this.$nextTick(() => {
        this.$refs.barcodeReaderRef?.closeScanner()
      })

      // The scan result comes from the html5-qrcode decode callback (async), not
      // a user gesture, so window.open() is blocked on iOS Safari. When that
      // happens, surface our own dialog whose button is a real <a target="_blank">
      // — a genuine tap on it is never popup-blocked.
      const newWindow = window.open(link, '_blank')
      if (newWindow) {
        newWindow.focus()
        return
      }

      this.scannedLink = link
      this.openLinkDialog = true
    },

    persist(key, value) {
      if (value) {
        localStorage.setItem(key, value)
      } else {
        localStorage.removeItem(key)
      }
    },
    checkSameAsDeliveryAddress() {
      if (this.form.sameAsDeliveryAddress) {
        this.setTaxFullName()
        return false
      } else {
        return true
      }
    },
    setTaxFullName() {
      if (this.checkTaxPersonal) {
        this.form.taxFirstName = this.form.first_name
        this.form.taxLastName = this.form.last_name
      } else {
        this.form.taxFirstName = ''
        this.form.taxLastName = ''
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onBlurAutoComplete() {
      if (this.form.postcode) {
        let filteredLocations = this.$store.getters[
          'thailandStore/getAll'
        ].filter(location => location.zipcode == this.form.postcode)

        if (filteredLocations.length > 0) {
          this.form.province = filteredLocations[0].province
          this.form.district = filteredLocations[0].amphoe
          this.form.sub_district = filteredLocations[0].district
        }
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    openResetModal() {
      this.dialog = true
    },
    closeResetModal() {
      this.dialog = false
    },
    closeLineRegisteredDialog() {
      this.lineRegisteredDialog = false
    },
    closeOpenLinkDialog() {
      this.openLinkDialog = false
      this.scannedLink = null
    },
    async confirmRegisteredOrderType() {
      this.persist(
        getRegisteredOrderStorageKey(this.$route.params?.slug),
        this.registeredOrderType,
      )
      this.registeredOrderTypeDialog = false

      // After confirming the registered order type, check for member request key again
      await this.checkMemberRequestKey()
    },
    reset() {
      this.$v.$reset()

      this.form = this.initForm

      localStorage.removeItem(
        getRegisteredStorageKey(this.$route.params?.slug),
      )
      localStorage.removeItem(
        getMemberVerifiedStorageKey(this.$route.params?.slug),
      )
      this.localMember = ''

      localStorage.removeItem(
        getRegisteredOrderStorageKey(this.$route.params?.slug),
      )
      this.registeredOrderType = null

      this.$store.dispatch('user/resetMember')
      this.$refs.sevenClubMember?.reset()
      this.closeResetModal()

      if (this.isLineChannelRef && !this.registeredOrderType) {
        this.registeredOrderTypeDialog = true
        this.prepareDataForm()

        return
      }

      this.goToCountDownPage()
    },
    resetBeforeFetchMember() {
      this.$v.$reset()

      this.form = this.initForm

      localStorage.removeItem(
        getRegisteredStorageKey(this.$route.params?.slug),
      )
      localStorage.removeItem(
        getMemberVerifiedStorageKey(this.$route.params?.slug),
      )
      this.localMember = ''

      this.$store.dispatch('user/resetMember')
      this.$refs.sevenClubMember?.reset()
    },
    submitForm() {
      this.$v.form.$touch()

      if (this.$v.form.$invalid) {
        for (let input in this.$v.form) {
          if (!input.includes('$') && this.$v.form[input].$error) {
            const element = document.querySelector(
              `[data-pptr='${input}']`,
            )
            if (element)
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })

            if (this.$refs[input]?.focus) {
              setTimeout(() => this.$refs[input]?.focus(), 300)
            }
            break
          }
        }
        return
      }

      if (this.$v.form.$error) {
        return
      }

      this.$store.dispatch('user/setData', this.form)

      if (
        this.isLineChannelRef &&
        this.registeredOrderType == 'offline'
      ) {
        this.lineRegisteredDialog = true
        return
      }

      this.goToCountDownPage()
    },
    goToCountDownPage() {
      this.$router.push({
        name: 'CountDown',
        params: { slug: this.$route.params?.slug },
      })
    },
    autoFormatIdCard(value, feild) {
      // Remove all non-digit characters
      let cleaned = value.slice(0, 17).replace(/[^\d]+/g, '')

      // Format the cleaned string
      let match = cleaned.match(
        /^(\d{0,1})(\d{0,4})(\d{0,5})(\d{0,2})(\d{0,1})/,
      )

      if (match) {
        cleaned = `${match[1] || ''}${
          match[2] ? '-' + match[2] : ''
        }${match[3] ? '-' + match[3] : ''}${
          match[4] ? '-' + match[4] : ''
        }${match[5] ? '-' + match[5] : ''}`
      }

      //   Update the input value
      this.form[feild] = cleaned
    },

    handleErrorCustomerIdentity(input) {
      if (this.$v.form[input].$error) {
        if (!this.$v.form[input].required) {
          return ''
        } else if (this.$v.form[input].$invalid) {
          if (
            (input === 'customer_identity' &&
              this.form.customerIdentityType === 'passport') ||
            (input === 'tax_id' &&
              this.form.checkTaxPersonalType === 'passport')
          ) {
            return 'Please enter a valid passport number.'
          }
          return input === 'tax_id'
            ? 'กรุณากรอกเลขประจำตัวผู้เสียภาษีให้ถูกต้อง'
            : 'กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง'
        }
      }
      return ''
    },

    handleVerifySevenClubMember() {
      this.localMember =
        localStorage.getItem(
          getMemberVerifiedStorageKey(this.$route.params?.slug),
        ) || ''

      this.prepareDataForm()
    },

    handleErrorSevenClubMember() {
      this.autoFocusField('email')
    },

    autoFocusField(field) {
      var element = document.querySelector(`[data-pptr='${field}']`)

      if (!element) {
        return
      }

      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })

      if (this?.$refs[field]?.focus) {
        setTimeout(() => this?.$refs[field]?.focus(), 300)
      }
    },
  },

  beforeDestroy() {
    this.$store.dispatch('user/resetMember')

    // Ensure close the scanner modal before opening the new window
    this.$nextTick(() => {
      this.$refs.barcodeReaderRef?.closeScanner()
    })
  },
}
</script>

<style lang="stylus" scoped>

.customer-form-section
    width 100%
    background-color #F9F9F9
.form-customer-layout
    width 100%
    @media medium
      width 100%
      padding 0
    @media small
      width 100%
      padding 0
.v-text-field.v-text-field--enclosed .v-text-field__details
  margin-bottom 0 !important
.v-messages.theme--light
  min-height 0px !important
.v-input--selection-controls
  margin-top 0px !important
.input-transparent
  background: transparent !important;
  border-color: transparent !important;
.branch-time
  display flex
  justify-content center
  align-items center
  margin-left -12px
  margin-right -12px
  .branch
    width 50%
    padding: 12px
    @media screen and (max-width: 960px)
      width 100%
  .time
     width 50%
     padding: 12px
     @media screen and (max-width: 960px)
       width 100%
   @media screen and (max-width: 960px)
    flex-direction column

::v-deep .v-input__slot {
  background: transparent !important;
  border-color: transparent !important;
}

.scb-easy-modal
  background: transparent linear-gradient(180deg, #A700FF 0%, #5500B9 100%) 0% 0% no-repeat padding-box;
.scb-card-qrcode
  background white
  border-radius: 8px;
  border: 1px solid #00000000;
  padding: 1.5rem
.button-back-scb
  border-color: white !important

.is-desktop
  display: block
  @media tablet
    display: none
.note-form-address
  display: flex
  flex-direction: column
  justify-content: flex-start
  align-items: center
  margin-top: -32px

  font-size: 0.875rem

  > div {
	text-align: center
  }

  @media tablet
    font-size: 0.875rem

  @media small
    font-size: 11px



.warning-tax-invoice
  width: 100%
  padding: 8px
  border: 1px solid #ccc
  border-radius: 8px
  font-size: 14px
  margin-top: 8px
  &.studio-7
    background: #f2f2f2;
    border: none

.warning-tax-invoice-title
  font-size: 15px
  font-weight: bold

.text-alert
  color: $color-red

.text-black
  color: $color-bnn-gray-medium

.action-container
  position: fixed
  bottom: 0
  left: 0
  width: 100%
  z-index: 8
  background-color: $color-dapp-gray-4;
  box-shadow: inset 0 .5px #7d7d7d
  margin-top: 16px

.header-modal-container
  padding: 16px 16px 0

.header-modal
  display: flex
  justify-content: center
  width: 100%

.body-modal
  padding: 16px

.header-modal-title
  font-size: 24px
  font-weight: bold
  font-family: $font-family-base !important
  align-self: center


.header-modal-close
  cursor: pointer
  color: $color-bnn-gray-light
  align-self: center

.customer-form-container {
    display: grid
    grid-template-columns: repeat(1, 1fr)
    gap 21px 14px

    .span-2 {
        grid-column: span 1

        @media screen and (min-width: 768px){
            grid-column: span 2
        }
    }

    @media screen and (min-width: 768px){
        grid-template-columns: repeat(2, 1fr)
    }
}

.customer-container {
    display: flex
    flex-direction: column
    gap: 24px
    margin-bottom: 24px

    &:last-child {
        margin-bottom: 120px
    }
}

::v-deep {
    .input-compact-container {
        &:first-child {
            .input-compact {
                border-radius: 5px 0 0 5px !important;

                &:not(.v-input--is-focused) {
                    fieldset {
                        border-right: none !important;
                    }
                }
            }


        }
        &:last-child {
            .input-compact {
                border-radius: 0 5px 5px 0 !important;
            }
        }
    }

    .no-border-shadow .v-input__control {
        border: none !important;
        box-shadow: none !important;
    }
}
.seven-club-member-container {
    width: 100%
    display: flex
    justify-content: center
}

.status-scm {
    &-success {
        color: #008900
        text-align: center
    }
    &-warning {
        color: #BF4800
        text-align: center
    }
}

.content-section {
    background-color: white
    padding: 32px 0

    &:empty {
        display: none;
    }

    @media screen and (min-width: 960px) {
        padding: 64px 0
    }

    &.is-show-form {
        &:first-child{
            margin-bottom: 8px
        }
    }
}

.text-seven-club-plus {
    background-clip: text;
    background-image: linear-gradient(68deg, #00ea67 21.65%, #00d3a2 51.69%, #00bedb 83.45%);
	color: transparent;
    -webkit-text-fill-color: transparent;
}

.text-seven-club-plus-dark {
    color: #0A7842;
}

.seven-club-plus-register-section {
    background-color: white
    color: black;
	font-weight: bold
    text-align: center
    padding: 0 0 64px

    @media screen and (min-width: 960px) {
        // padding: 48px 32px
    }

    .seven-club-plus-register {
		display: flex
		flex-direction: column
		align-items: center
		justify-content: center
		gap: 16px
		padding: 32px 16px

		border-radius: 12px

		background: #f3f3f3 url('~@/assets/seven-club-member/banner-overlay-7-club-plus.png') no-repeat bottom/contain;

    }
}

.flash-message-container {
	display: flex
	flex-direction: column
	justify-content: center
	align-items: center
	gap: 24px
	padding: 12px

	text-align: center;
}

.register-delivery-method-modal
  display: flex
  flex-direction: column
  gap: 24px
  padding: 12px

.register-delivery-method-title
  font-size: 16px
  font-weight: 500

.register-delivery-method-list
  display: grid
  grid-template-columns: repeat(2, 1fr);
  gap: 16px

  .item
    display: flex
    flex-direction: column
    align-items: center
    gap: 11px
    padding: 16px
    border-radius: 8px
    border: 1.2px solid $color-dapp-gray-3
    cursor: pointer

    &.-is-selected
      background-color: $color-fill-radio-button
      border: 1.2px solid $color-bnn !important

      .checkmark
        border: 5.5px solid $color-bnn

    .item-label
      flex: 1
      font-size: 16px
      font-weight: 500
      color: rgba(#000000, 0.70)

    .item-icon
      width: 48px
      height: 48px
      display: flex
      align-items: center
      justify-content: center

      img
        object-fit: contain
        width: 100%
        height: 100%

    .checkmark
      width: 16px
      height: 16px
      border-radius: 50%
      border: 1px solid #d2d2d7
      transition: border .1s

.action-content
  display: flex
  justify-content: flex-end
  gap: 16px
  padding-block: 16px
  box-sizing: border-box
  @media screen and (min-width: 768px)
    display: flex
    justify-content: flex-end

::v-deep .btn-action
  flex: 1 !important
  @media screen and (min-width: 768px)
    flex: 0 0 auto !important
</style>
